(function () {
  console.log("Mini-cart Flickity init script loaded (no jQuery)");

  function getFlickityConstructor() {
    // If theme already exposed it globally
    if (window.Flickity) {
      return window.Flickity;
    }

    // Use the CommonJS wrapper you showed: var require_flickity = __commonJS(...)
    if (typeof window.require_flickity === "function") {
      try {
        return window.require_flickity();
      } catch (e) {
        console.warn("Mini-cart: error calling require_flickity()", e);
        return null;
      }
    }

    console.warn("Mini-cart: Flickity constructor not found");
    return null;
  }

  function initMiniCartFlickity(slider) {
    if (!slider) return;
    if (slider.dataset.flickityInitialized === "true") return;

    var FlickityCtor = getFlickityConstructor();
    if (!FlickityCtor) return;

    var items = slider.querySelectorAll(".mini-cart-related-products__item");
    console.log("Mini-cart: found items =", items.length);
    if (items.length <= 1) {
      console.log("Mini-cart: only one item, skip Flickity");
      return;
    }

    // Initialize Flickity on this slider
    new FlickityCtor(slider, {
      cellAlign: "left",
      contain: true,
      wrapAround: true,
      prevNextButtons: true, // arrows
      pageDots: false, // dots
      draggable: true,
      autoPlay: 5000, // 5 seconds
      pauseAutoPlayOnHover: false,
    });

    slider.dataset.flickityInitialized = "true";
    // console.log("Mini-cart: Flickity initialized");
  }

  function initAllSliders() {
    document
      .querySelectorAll(".js-mini-cart-flickity")
      .forEach(initMiniCartFlickity);
  }

  // Init on DOM ready
  document.addEventListener("DOMContentLoaded", function () {
    // console.log("Mini-cart: DOMContentLoaded");
    initAllSliders();
  });

  // Watch for dynamically injected mini-cart content
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches && node.matches(".js-mini-cart-flickity")) {
          // console.log("Mini-cart: slider added via mutation (direct)");
          initMiniCartFlickity(node);
        } else if (node.querySelector) {
          var slider = node.querySelector(".js-mini-cart-flickity");
          if (slider) {
            // console.log("Mini-cart: slider added via mutation (descendant)");
            initMiniCartFlickity(slider);
          }
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // ---------------------------------------------------------------------------
  // Upsell "Add to cart" buttons inside mini-cart (AJAX add)
  // ---------------------------------------------------------------------------
  function handleUpsellAddToCartClick(event) {
    var button = event.target.closest(".mini-cart-related-products__atc");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");
    if (!variantId) return;

    button.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(function (data) {
        // Optional: dispatch a custom event so theme's mini-cart can listen & refresh,
        // but WITHOUT calling its internal _openMiniCart on a bad instance.
        var evt = new CustomEvent("jg:upsell-added-to-cart", {
          detail: { item: data },
        });
        document.documentElement.dispatchEvent(evt);

        // Fallback: simple reload to refresh mini-cart totals/items
        window.location.reload();
      })
      .catch(function (err) {
        console.error("Mini-cart upsell add-to-cart error:", err);
        button.disabled = false;
      });
  }

  document.addEventListener("click", handleUpsellAddToCartClick);
})();
